<script>
  import { onMount } from 'svelte'
  import Layout from '~/Components/Layout/Layout'
  import ContactMolecule from '~/Components/Molecules/Contact'
  import { submitContactForm } from '~/Library/api'
  import store from '~/Library/store'

  let sent = false
  let contact 
  let isError = false 
  let isSending = false

  onMount(() => {
    window.scrollTo(0, 0)
  })

  function submit(e){
    e.preventDefault()
    const {subject, message} = contact

    if (!isSending){
      isSending = true
      submitContactForm({
        subject, 
        message,
        timestamp: Date.now(),
        sender: $store.user.email
      }).then((rsp) => {
        sent = true
      }).catch((err) => {
        isSending = false
        isError = true
      })
    }
  }

  function formEdited(e){
    contact = e.detail 
  }
</script>

<Layout>

  <div class="contact">

    <img class="contact__background left" src="static/shapes/rectangle.svg" alt="">

    <div class="contact__left">

      <h1 class="heading">Contact Us</h1>

      <p>We’re here to talk. Please do not hestitate to get in touch with us via email or our contact form.</p>

    </div>

    <div class="contact__right">

      <div class="contact__email">

        <img src="static/icons/email.svg" alt="">

        <span class="contact__email-text">support@next-4-me.com</span>

      </div>

      {#if !sent}

        <form on:submit={submit} class="contact__form">

          <ContactMolecule on:formEdited={formEdited} />
        
          <button class="contact__cta">Submit</button>

        </form>

      {:else}

        <div class="contact__success">

          <img src="static/icons/success.svg" alt="">

          <p>Thank you for your message! <br /> We aim to get back to you within 2 working days!</p>

        </div>

      {/if}

    </div>

    <img class="contact__background right" src="static/shapes/rectangle.svg" alt="">

  </div>

</Layout>

<style lang="scss">

  .contact {

    $this: &; 

    display: flex;
    position: relative;
    padding: 4rem 0;

    &__background {
      position: absolute;
      height: 50rem;
      width: 50rem;
      &.left {
        top: -400px;
        left: -550px;
        transform: rotate(50deg);
      }
      &.right {
        z-index: -10;
        right: -300px;
        bottom: -280px;
        transform: rotate(60deg);
      }
    }

    &__left {

      flex-basis: 40%;
      flex-shrink: 0;

      .heading {
        margin-bottom: 2rem;
      }   

    }

    &__right {

      display: flex;
      flex-direction: column;
      align-items: center;
      width: 30rem;
      max-width: 100%;
      position: relative;
      margin: 0 auto;
      background: #FFFFFF;
      box-shadow: 0px 50px 100px rgba(0, 0, 0, 0.10);
      border-radius: 1.25rem;
      padding: 3.5rem 0;

      #{$this}__email {
        
        display: flex;
        position: absolute;
        align-items: center;
        padding: 1.125rem 1.25rem;
        background: var(--dark-background);
        border-radius: 1rem;
        top: -40px; 

        img {
          margin-right: 1rem;
        }

        &-text {

          color: white;
          font-size: 0.875rem;

        }

      }

      #{$this}__form {
        width: 100%;
        padding: 0 1rem;
        box-sizing: border-box;
      }

      #{$this}__cta {

        background-color: var(--accent-colour);
        padding: 1.125rem 2.75rem;
        align-self: flex-start;
        width: fit-message; 
        border-radius: 2rem;
        color: white;
        outline: none;
        font-size: 1.125rem;
        border: none;
        cursor: pointer;

      }
      
      #{$this}__success {

        display: flex;
        margin-top: 1rem;
        align-items: center;

        p {
          margin-left: 1rem;
          color: var(--heading-colour);
          font-size: 0.875rem;
          line-height: 150%;
        }

      }

    }

    @media only screen and (max-width: 576px) {

      flex-direction: column;

      &__right {

        margin-top: 6rem;

        #{$this}__success {
          margin: 0.5rem 2rem;
        }

      }

    }

  }

</style>